// start:ng42.barrel
export * from './points-description.component';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/points-description/index.ts